export default "__VITE_ASSET__Mpx4Q8lR__"